// import { baselightTheme } from "./theme/DefaultColors";
import { Themefunc } from './theme/DefaultColors';
import { CssBaseline, ThemeProvider } from '@mui/material';

import './assets/css/index.scss'
import Popup from './components/popup/popup';
import Showclasses from './components/showclasses';
import Otp from './veiws/Website/authentication/otp/otp';
import Home from './veiws/Website/Home/Home';
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Loader from './components/loader/loader'
import Wasily from './components/xaoasoft/label';
import { registerServiceWorker } from './swRegistration';

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [notificationPermission, setNotificationPermission] = useState('default');

  // Function to show notification - SIMPLE AND RELIABLE
  const showSimpleNotification = (title, body) => {
    console.log('Attempting to show notification:', title, body);
    
    // Method 1: Try the Notification API directly
    if (Notification.permission === 'granted') {
      try {
        const notification = new Notification(title, {
          body: body,
          icon: '/images/icon/android-chrome-192x192.png',
          badge: '/images/icon/icon-72x72.png',
          vibrate: [200, 100, 200],
          requireInteraction: true,
          silent: false
        });
        
        notification.onclick = () => {
          console.log('Notification clicked');
          window.focus();
          notification.close();
        };
        
        console.log('✅ Notification shown successfully');
        return true;
      } catch (error) {
        console.error('Error showing notification:', error);
      }
    } else {
      console.log('Notification permission not granted. Status:', Notification.permission);
    }
    
    // Method 2: Try through service worker
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      try {
        navigator.serviceWorker.controller.postMessage({
          type: 'SHOW_NOTIFICATION',
          title: title,
          body: body
        });
        console.log('✅ Notification sent via service worker');
        return true;
      } catch (error) {
        console.error('Error via service worker:', error);
      }
    }
    
    return false;
  };

  // Check fees and show notification
  const checkFeesAndNotify = useCallback(() => {
    console.log('=== checkFeesAndNotify called ===');
    
    // Get fees from localStorage
    let fees = localStorage.getItem('fees');
    if (!fees) fees = localStorage.getItem('user_fees');
    if (!fees) fees = '0';
    
    const feesAmount = parseFloat(fees);
    console.log('Fees amount:', feesAmount);
    console.log('Notification permission:', Notification.permission);
    
    // Check last notification date
    const lastNotificationDate = localStorage.getItem('lastFeeNotificationDate');
    const today = new Date().toDateString();
    console.log('Today:', today);
    console.log('Last notification:', lastNotificationDate);
    
    // Should we notify?
    const shouldNotify = feesAmount > 0 && lastNotificationDate !== today && Notification.permission === 'granted';
    console.log('Should notify:', shouldNotify);
    
    if (shouldNotify) {
      // Show notification
      const success = showSimpleNotification(
        'Fee Alert - حکیم الامت دارلعلوم',
        `You have unpaid fees: ${feesAmount} rupees. Please clear your dues.`
      );
      
      if (success) {
        // Store that we showed notification today
        localStorage.setItem('lastFeeNotificationDate', today);
        console.log('Notification shown and date stored');
      }
    } else if (feesAmount > 0 && Notification.permission === 'granted') {
      console.log('Already shown today or permission issue');
    } else if (feesAmount > 0 && Notification.permission !== 'granted') {
      console.log('Permission not granted. Status:', Notification.permission);
    }
  }, []);

  // Test notification function (use this for debugging)
  const testNotification = useCallback(() => {
    console.log('=== TEST NOTIFICATION ===');
    if (Notification.permission === 'granted') {
      showSimpleNotification('Test Notification', 'If you see this, notifications are working!');
    } else {
      console.log('Requesting permission...');
      Notification.requestPermission().then(perm => {
        console.log('Permission granted?', perm);
        if (perm === 'granted') {
          setTimeout(() => {
            showSimpleNotification('Test Notification', 'Now notifications are working!');
          }, 500);
        }
      });
    }
  }, []);

  useEffect(() => {
    console.log('=== App Component Mounted ===');
    
    // Set test fees only once
    if (!localStorage.getItem('fees_initialized')) {
      localStorage.setItem('fees', '500');
      localStorage.setItem('fees_initialized', 'true');
      console.log('Test fees set to 500');
    }
    
    // Remove old notification date for testing
    // localStorage.removeItem('lastFeeNotificationDate');
    
    // Check if running as PWA
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    console.log('Running in standalone mode (installed PWA):', isStandalone);
    
    // Register service worker
    registerServiceWorker();
    
    // Check notification permission status
    if ('Notification' in window) {
      console.log('Notification API is supported');
      console.log('Current permission status:', Notification.permission);
      setNotificationPermission(Notification.permission);
      
      // If permission already granted, show notification after delay
      if (Notification.permission === 'granted') {
        console.log('Permission already granted, will show notification in 5 seconds');
        const timer = setTimeout(() => {
          console.log('Timer triggered - checking fees');
          checkFeesAndNotify();
        }, 5000);
        
        return () => clearTimeout(timer);
      } 
      // If permission not decided yet, request it
      else if (Notification.permission === 'default') {
        console.log('Waiting for permission request...');
        // Request permission on button click or after delay
        const timer = setTimeout(() => {
          Notification.requestPermission().then(permission => {
            console.log('Permission request result:', permission);
            setNotificationPermission(permission);
            if (permission === 'granted') {
              setTimeout(() => checkFeesAndNotify(), 2000);
            }
          });
        }, 3000);
        
        return () => clearTimeout(timer);
      }
    } else {
      console.log('Notification API not supported in this browser');
    }
    
    // Listen for visibility change (app comes to foreground)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        console.log('App came to foreground');
        if (Notification.permission === 'granted') {
          checkFeesAndNotify();
        }
      }
    });
    
    // Add beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      console.log('beforeinstallprompt event fired');
    });
    
    // Add global test function
    window.testNotification = testNotification;
    window.checkFeesManually = checkFeesAndNotify;
    window.setTestFees = (amount) => {
      localStorage.setItem('fees', amount);
      localStorage.removeItem('lastFeeNotificationDate');
      console.log(`Fees set to ${amount}`);
      checkFeesAndNotify();
    };
    
    console.log('Debug commands available:');
    console.log('- window.testNotification() - Show test notification');
    console.log('- window.checkFeesManually() - Check fees and notify');
    console.log('- window.setTestFees(1000) - Set fees to 1000 and notify');
    
  }, [checkFeesAndNotify, testNotification]);
  
  // Check for User_Data changes
  const [getToken, setGetToken] = useState(localStorage.getItem('User_Data'));
  
  useEffect(() => {
    setGetToken(localStorage.getItem('User_Data'));
    if (localStorage.getItem('User_Data') && Notification.permission === 'granted') {
      console.log('User logged in, checking fees');
      setTimeout(() => checkFeesAndNotify(), 3000);
    }
  }, [localStorage.getItem('User_Data'), checkFeesAndNotify]);
  
  const theme = Themefunc();
  Showclasses();
  
  return (
    <ThemeProvider theme={theme}>
      <Popup />
      <Loader />
      {getToken !== '' && getToken !== undefined && getToken !== null ? 
        <Home />
        :
        <Otp />
      }
      <CssBaseline />
      <Wasily />
      
      {/* Debug Panel - Shows only in development */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: 'rgba(0,0,0,0.8)',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          fontSize: '12px',
          zIndex: 9999,
          fontFamily: 'monospace'
        }}>
          <div>Notif: {Notification.permission}</div>
          <div>Fees: {localStorage.getItem('fees') || '0'}</div>
          <button onClick={testNotification} style={{marginTop: '5px'}}>Test Notif</button>
        </div>
      )}
    </ThemeProvider>
  )
}

export default App;